<div class="modal-body p-0">
    <img class="img-fluid" src="{{ imagemSelecionada }}" />
</div>
<div class="modal-footer">
    <button type="button" class="close text-white" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>